import React from "react";

export const Avatar = ({ width }) => {
  return (
    <div>
      <img src="/media/images/avatar.png" alt="" style={{ width }} />
    </div>
  );
};
